import React, { useContext, useState } from 'react';
import { StoreContext } from "../../store/index";
import { setCookie } from '../../utils/cookie';
import { 
    Background, 
    BackgroundOverlay, 
    Logo, 
    Title, 
    Subtitle,
    // YearsInput,
    YearsButton,
    ButtonWrapper,
    LanguageWrapper,
    OverlayPopup,
    Popup,
} from './styles'
import logo from '../../assets/checking-year/bacchus-drinks-logo.svg'
import LanguageSelect from "../../common/LanguageSelect";
import { useTranslation } from "react-i18next";

const CheckingYear = () => {
  const { redirect } = useContext(StoreContext);
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const checkingYears = (years) => {
    // if(years.length === 4){
        // const currentYear = new Date().getFullYear()
        // setCookie('years', currentYear - years)
        // redirect(currentYear - years)
        setCookie('years', years)
        redirect(years)
    // }
  }
    
  return (
    <Background>
      <BackgroundOverlay>
        <Logo src={logo} />
        <Title>{t("theGate")}</Title>
        <Subtitle blue>{t("weAreHappy")}</Subtitle>
        {/* <YearsInput 
            placeholder="YYYY" 
            type="number" 
            maxLength="4"
            onChange={(e) => checkingYears(e.target.value)}
        /> */}
        <ButtonWrapper>
          {/* <YearsButton red onClick={() => checkingYears(12)}>{t("iHaveLess")}</YearsButton> */}
          <YearsButton red onClick={() => setIsPopupOpen(true)}>{t("iHaveLess")}</YearsButton>
          <YearsButton onClick={() => checkingYears(30)}>{t("iHave18")}</YearsButton>
        </ButtonWrapper>
        {/* <Subtitle>Please enter your year of birth</Subtitle> */}
        <LanguageWrapper>
          <LanguageSelect/>
        </LanguageWrapper>
        {isPopupOpen &&
          <OverlayPopup onClick={() => setIsPopupOpen(false)}>
            <Popup onClick={() => setIsPopupOpen(false)}>
                <h3 style={{ marginBottom: '50px', textAlign: 'center' }}>{t("areYouSure18")}</h3>
                <ButtonWrapper>
                  <YearsButton red onClick={() => checkingYears(12)}>{t("iHaveLess")}</YearsButton>
                  <YearsButton onClick={() => checkingYears(30)}>{t("iHave18")}</YearsButton>
                </ButtonWrapper>
            </Popup>
          </OverlayPopup>
        }
      </BackgroundOverlay>
    </Background>
  );
}

export default CheckingYear;
